export default {
    en: {
        TAGS_ADD: 'Tag or KU/KSA/TKS to Add'
    }
};
